export default "__VITE_ASSET__cb710cb7__"